import StatusPage from 'components/errors/StatusPage';

const StatusPage404 = () => (
  <StatusPage code="404" message="Sorry, we can’t find the page you are looking for." />
);

export default StatusPage404;
